<div class="mb20">
  <div ngbAccordion #existingSearchProfiles="ngbAccordion" [closeOthers]="true">
    @for (formGroup of formArray().controls; track formGroup; let i = $index) {
      <div
        [ngbAccordionItem]="'search-profile-panel-' + i"
        (shown)="getSearchProfileData(i)"
        #accordionItem="ngbAccordionItem"
      >
        <div ngbAccordionHeader>
          @if (searchProfilesInfoPayload[i]) {
            <app-search-profile-info
              [class.hide]="!accordionItem.collapsed"
              [searchProfile]="searchProfilesInfoPayload[i]"
              [showToggleOption]="false"
              [showMarketingTypeBadge]="!isSelfRegistration()"
              (editProfile)="toggleSearchProfile(i)"
              (deleteProfile)="onDeleteSearchProfile(i)"
            >
            </app-search-profile-info>
          }
        </div>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              @if (searchProfilesInfoPayload[i]) {
                <app-search-profile-details
                  [form]="formGroup"
                  [constants]="constants()"
                  [searchProfile]="searchProfilesInfoPayload[i]"
                  [showMarketingType]="showMarketingType()"
                  [internalizationSettings]="internalizationSettings()"
                  [enableEditingOfSearchingSinceDate]="true"
                  [landlordCityPacket]="landlordCityPacket()"
                  [onlyShowConfiguredCityPartsToUser]="
                    onlyShowConfiguredCityPartsToUser()
                  "
                  [isRegistration]="isRegistration()"
                  [defaultObjectTypes]="defaultObjectTypes()"
                ></app-search-profile-details>
              }
              <div class="row">
                <app-button
                  class="col"
                  [type]="'light-bordered'"
                  (clickEvent)="cancelEdit(i)"
                >
                  {{ 'general.cancel_a' | translate }}
                </app-button>
                <app-button
                  [disabled]="formGroup.invalid"
                  class="col"
                  [type]="'light-bordered'"
                  (clickEvent)="updateSearchProfile(i)"
                >
                  {{ 'search_profile.add_search_profile_a' | translate }}
                </app-button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    }
  </div>
</div>

@if (!hasOpenPanels) {
  <app-button
    [type]="'light-bordered'"
    [iconLeft]="'add'"
    (clickEvent)="newSearchProfile()"
  >
    {{ 'search_profile.add_search_profile_a' | translate }}
  </app-button>
}
@if (isOfflineUser() && !isSelfRegistration()) {
  <app-form-field class="d-block mt10">
    <app-checkbox
      [label]="'search_profile.enable_more_data_offline_member_l' | translate"
      [ngModel]="sensitiveDataAccessible()"
      (ngModelChange)="onSensitiveDataAccessible($event)"
    >
    </app-checkbox>
  </app-form-field>
}
@if (showInviteToRegister()) {
  <app-form-field class="d-block mt10">
    <app-checkbox
      [label]="'search_profile.invite_to_register_online_member_l' | translate"
      [disabled]="hasSalesSearchProfile"
      [ngbTooltip]="
        hasSalesSearchProfile
          ? ('member_search_profile.sales_disabled_l' | translate)
          : null
      "
      [ngModel]="inviteToRegister()"
      (ngModelChange)="onInviteToRegisterChange($event)"
    >
    </app-checkbox>
  </app-form-field>
}
